import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import { Box, CircularProgress } from '@mui/material';
import { useAuthState } from '../../stores/authStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import { useEventState } from '../../stores/eventStore';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION, REQUEST_STATUS_LIST } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import CommonRequests from '../../sharedcomponents/commonRequest/commonRequest';
import AdminNote from '../../sharedcomponents/adminNote/adminNote';
const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const MyTicket = (props) => {

    const showSearch = true;
    // const openDialog = useState(false);
    //const transittype = useState(null);
    const eventState = useEventState();
    const history = useHistory();
    const authState = useAuthState();
    const loading = useState(false);
    const allData = useState();
    const allListData = useState([]);
    const eventData = useState(null);
    const userID = useState(null);
    const openNoteDialog = useState(false);
    // const moduleIndex = useState(0)
    const requestPending = useState(null);

    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const [isParticipant, setIsParticipant] = React.useState(false)
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const requestNote = useState(null);
    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (!Helper.isAdminUser(userInfo) ||
            !Helper.isEventAdmin(userInfo) ||
            !Helper.isEventAgent(userInfo) ||
            !Helper.isEventStaff(userInfo)) {
            setIsParticipant(true)
        } else {
            setIsParticipant(false)
        }
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            const userInfo = Helper.getStorage('userInfo');
            if (!Helper.isAdminUser(userInfo)) {
                const permissions = eventState.permissions.attach(Downgraded).get();
                if (permissions && permissions.length > 0) {
                    setModPermission(Helper.getModuleAccessPermission(permissions, 'TICKET'));
                }
            }
            else if (Helper.isAdminUser(userInfo)) {
                setModPermission(FULL_PERMISSION)
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getTicketList();
            }
        }
    }, [modPermission]);

    const getTicketList = () => {
        let participantList = [];
        const userInfo = Helper.getStorage('userInfo');
        loading.set(true);
        ApiHelper.get(APIURLConstants.GET_TICKETS(eventData.get().eventID, false, userInfo.userID))
            .then((res) => {
                if (res.data) {
                    let data = res.data;
                    let requestData = [];
                    if (data.length > 0) {
                        data.map((item) => {
                            if (participantList.indexOf(item.participant) == -1) {
                                participantList.push(item.participant);
                            }
                            requestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'hotelBookID',
                                        hotelBookID: item.ticketID,
                                        width: '0.05',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.25',
                                        showLabel: false,

                                    },

                                    {
                                        label: 'Submitted By',
                                        key: 'createdBy',
                                        createdBy: item.createdByName,
                                        width: '0.25',
                                        inColumn: true,
                                    },

                                    {
                                        label: 'Date',
                                        key: 'createdDate',
                                        createdDate: !Helper.IfDateIsNULL(
                                            item.createdDate
                                        )
                                            ? Helper.FormatDate(
                                                item.createdDate
                                            ) +
                                            ' ' +
                                            Helper.FormatTime(
                                                item.createdDate
                                            )
                                            : '',
                                        width: '0.25',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Total Tickets',
                                        key: 'totalTickets',
                                        totalTickets: String(item.totalTickets),
                                        width: '0.25',
                                        inColumn: true,
                                        alignCenter: true
                                    },
                                    // {
                                    //     label: 'History',
                                    //     key: 'auditHistory',
                                    //     auditHistory: "",
                                    //     width: '0.05',
                                    //     showLabel: false,
                                    //     showChips: false,
                                    //     inColumn: true,
                                    // },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.10',
                                        showStatusIcon: true,
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'editnote',
                                        editnote: item.note,
                                        width: '0.1',
                                    },
                                    // {
                                    //     label: 'Action',
                                    //     key: 'All',
                                    //     all: 'All',
                                    //     width: '0.15',
                                    //     inColumn: true,
                                    //     alignCenter: true,
                                    // },
                                ],
                                selected: false,
                            });
                        });
                    } else {
                        <StyledTableRow>
                            <StyledTableCell colSpan="7" align="center">
                                No data found
                            </StyledTableCell>
                        </StyledTableRow>;
                    }
                    setShowSearchRec(false);
                    allData.set(requestData);
                    allListData.set(requestData);
                    setFilters({
                        hotelName: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    });
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const handleConfirmation = () => {
        let deleteRequests = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.ticketID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_TICKETS, {
            ticketIDs: deleteRequests.join(','),
            ModifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    setAll.set(false);
                    getTicketList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const closeNoteDialog = () => {
        openNoteDialog.set(false);
        requestNote.set(null);
    };
    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getTicketList();
    };

    const onActionClick = (item, action) => {
        let newData = [...allData.attach(Downgraded).get()];
        let index = newData.findIndex(
            (data) => data.actualData.ticketID == item.actualData.ticketID
        );
        let newItem = newData[index];
        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            ticketID: newItem.actualData.ticketID,
            status: isStatus,
            userID: userID.get(),
            action,
            note: newItem.note,
        });
        openNoteDialog.set(true);
        // let postData = {
        //     "eventID": eventData.get().eventID,
        //     "ticketID": newItem.actualData.ticketID,
        //     "modifiedBy": userID.get(),
        //     "status": isStatus
        // }
        // loading.set(true);
        // ApiHelper.post(APIURLConstants.UPDATE_EVENT_STATUS, postData).then(res => {
        //     console.log("res", res);
        //     loading.set(false);
        //     getTicketList();
        // }).catch((error) => {
        //     loading.set(false);
        //     // state.isDisable.set(false);
        //     console.log('Error : ', error);
        // });
    };
    const onPendingAction = (item) => {
        let newData = [...allData.attach(Downgraded).get()];

        let index = newData.findIndex(
            (data) => data.actualData.ticketID == item.actualData.ticketID
        );
        let newItem = newData[index].actualData;

        const isStatus = 1;

        requestPending.set({
            status: isStatus,
            userID: userID.get(),
            ticketID: newItem.ticketID,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };
    const updateNote = async (value) => {
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        console.log("newRequestNote", newRequestNote);
        newRequestNote['note'] = value;
        const statusUpdate = {
            "eventID": eventData.get().eventID,
            "ticketID": newRequestNote.ticketID,
            "modifiedBy": newRequestNote.userID,
            "status": newRequestNote.status,
            "note": newRequestNote.note,
        };
        ApiHelper.post(APIURLConstants.UPDATE_EVENT_STATUS, statusUpdate)
            .then(async result => {
                if (result.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Status updated successfully',
                    });
                    await getTicketList();
                    await closeNoteDialog();
                }
            }).catch(err => {
                console.log(err)
            })

    }
    //// After Completed New Request Page Then Un Commet
    const redirectToEditHotelRequest = (data) => {
        const row = data.actualData;
        const path = generatePath(RouteConstants.EDIT_EVENT_TICKET, {
            eventID: eventData.get().eventID,
            ticketID: row.ticketID,
        });
        history.push({
            pathname: path,
            state: { ticketState: row },
        });
    };

    const onAddRequest = () => {
        // console.log('true');
        // openDialog.set(true);
        props.history.push({
            pathname: generatePath(RouteConstants.CREATE_EVENT_TICKET, { 'eventID': eventData.get().eventID }),
            state: {},
        });
    };

    const onDelete = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    return (
        <Box sx={{
            width: '100%',
            overflow: 'auto',
            maxHeight: 'calc(100vh - 70px)',
        }}>
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ?
                    <UnauthorizedUI showLogout={false} />
                    :
                    (
                        <CommonRequests
                            // new props
                            data={allData.attach(Downgraded).get()}
                            editRow={redirectToEditHotelRequest}
                            handleClick={onAddRequest}
                            title={''}
                            disableAdd={allData.attach(Downgraded).length != 0 ? true : false}
                            buttonTitle={'Add'}
                            deleteRows={onDelete}
                            showSearch={showSearch}
                            searchLabel={'Search'}
                            showFilter={isParticipant ? false : true}
                            filters={filters}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            onActionClick={onActionClick}
                            onPendingAction={onPendingAction}
                            getResults={getTicketList}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            handlePageChange={handlePageChange}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            moduleToShow={"Ticket"}
                            modPermission={modPermission}
                        />
                    )}
            {openNoteDialog.get() && (
                <AdminNote
                    open={openNoteDialog.get()}
                    title="Ticket Note"
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}

            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
}
export default {
    routeProps: {
        path: RouteConstants.EVENT_TICKET_PARTICIPANT,
        component: MyTicket,
    },
    name: 'MyTicket',
};